import managerOperateRecord from '@/views/record/manager-operate-record';
import loginRecord from '@/views/record/login-record';

const recordRouters = [
    { path: '/managerOperateRecord', component: managerOperateRecord },
    { path: '/loginRecord', component: loginRecord },
]

export default recordRouters;


// WEBPACK FOOTER //
// ./src/router/record/index.js